import {Duree} from '../../shared/models/duree.model';

export class NouvelEvenementDto {
	dateEvenement: string;
	duree: Duree;
	commentaire: string;

	constructor(dateEvenement: string, duree: Duree, commentaire: string) {
		this.dateEvenement = dateEvenement;
		this.duree = duree;
		this.commentaire = commentaire;
	}
}
